import React from "react";
import { uiActions } from "../../store/ui-slice";
import { useDispatch } from "react-redux";
import "./Notification.scss";

const Notification = (props) => {
  const dispatch = useDispatch();
  const hideNotification = () => {
    dispatch(uiActions.hideNotification());
  };
  return (
    <div className="alert">
      <button type="button" onClick={hideNotification}>
        X
      </button>
      <h4>{props.title}</h4>
      <p>{props.message}</p>
    </div>
  );
};

export default Notification;
